// Whether ONE of the owner's own material rows fits how THIS section is produced -- the single definition the
// Malzeme dropdown (MaterialSelect), the add/manage button label (ManageOwnMaterialsButton) and the "add a
// material first" gate (ManufacturingLineLists#ownMaterialMissing) all read, so the three can never disagree on
// what "a material that fits" means. It mirrors the server-side material score exactly:
//   - carton (Frank::MaterialScores::CartonMaterialUserPrice) splits on the bobbin flag: a row is a bobbin-roll
//     row or a folded-sheet row, so it fits ONLY the matching bobbin state. An ABSENT flag is a NON-bobbin row.
//   - hard cardboard (Frank::MaterialScores::HardCardboardMaterialUserPrice) is built around the dieline's board
//     thickness -- only a row stocked at EXACTLY that thickness fits; until the thickness is known, none do.
//   - every other material key has no such split, so every row fits.
export const materialFitsSection = (material, { materialKey, bobbinEnabled, boardThicknessMm }) => {
  if (materialKey === 'carton_material') {
    return Boolean(material.bobbin_enabled) === Boolean(bobbinEnabled);
  }
  if (materialKey === 'hard_cardboard_material') {
    const hasBoardThickness = boardThicknessMm !== undefined && boardThicknessMm !== null;
    return hasBoardThickness && Number(material.thickness_in_mm) === Number(boardThicknessMm);
  }
  return true;
};

// The rows of `materials` that fit the section, by the same test above.
export const compatibleMaterials = (materials, criteria) => (
  materials.filter((material) => materialFitsSection(material, criteria))
);
